import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router"
import { App } from "./App"
import { initAnalytics } from "@/lib/analytics"

import "../styles/globals.css"

// Use createRoot for reliable client-side routing.
// SSR still provides full HTML for bots/crawlers (they don't execute JS).
// For users, the client renders the React tree from scratch — the SSR HTML
// is visible until React takes over, preventing any blank-screen flash.
initAnalytics()

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)
